import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import dayjs from 'dayjs';

import { Layout } from '../../components/Layout';
import {
  $scheduleData,
  getScheduleEvent,
} from '../../effector/schedule';

import { styles } from '../ProgramDetails/ProgramDetails.styles';
import { NearFilmsTable } from '../../components/NearFilmsTable';

export const Schedule = () => {
  useEffect(() => {
    getScheduleEvent();
  }, [])

  const schedule = useStore($scheduleData);

  const scheduleData = (schedule || []).reduce((result, s) => {
    s.showtimes.map((schedule) => {
      result.push({
        ramblerAfishaId: schedule.ramblerAfishaId,
        datetime: schedule.datetime,
        isSaleAvailable: schedule.isSaleAvailable,
        kinohodId: schedule.kinohodId,
        event: {
          slug: s.slug,
          title: s.title,
          ageRestriction: s.ageRestriction,
          director: s.director,
          type: s.type,
          buyUrl: s.buyUrl
        }
      })
    })

    return result;
  }, []).sort((a, b) => (dayjs(a.datetime).isAfter(dayjs(b.datetime)) ? 1 : -1))

  return (
    <Layout>
      <div className={styles.title}>расписание</div>
      <NearFilmsTable items={scheduleData || []} withoutFull />
    </Layout>
  )
}
